import React, { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import { Download } from '../../../_lib/components/Download';
import { Namespace } from '../../../translation/namespace';
import { DefaultView, Views } from '../../../types/BlockWithViews';
import { IFileItem } from '../../../types/api/FileItem';
import { asBlock } from '../../../_lib/BlockFetcher';
import { BlockType } from '../../../types/api/ElementType';

export type FaqAttachedFilesProps = Views<DefaultView<{ attachments: IFileItem[] }>>;

function FaqAttachedFiles({ views }: FaqAttachedFilesProps) {
  const { t } = useTranslation(Namespace.FaqList);
  // no empty ul
  if (views?.default?.embedded?.attachments.length >= 1) {
    return (
      <div className="faq-list__attached-files" key="faq-list__attached-files">
        <h3 className="faq-list__attached-files-headline font-bold-16-24">{t('attachedFilesHeadline')}</h3>
        <ul className="faq-list__attached-files-list">
          {views.default.embedded.attachments.map(attachment => (
            <li className="faq-list__attached-files-list-item" key={attachment.url}>
              <Download {...attachment} />
            </li>
          ))}
        </ul>
      </div>
    );
  }
  return null;
}

export const AttachedFAQFilesBlock = asBlock(FaqAttachedFiles, BlockType.attachedfiles);
export type AttachedFAQFilesBlock = ComponentProps<typeof AttachedFAQFilesBlock>;
